import { connect } from 'react-redux';

import { StoreState } from '../../../../../reducers';
import ButtonsPanel from '../../../../../components/Editor/Thumbnails/Column/ButtonsPanel';
import { EditorType } from '../../../constants';

const mapStateToProps = (state: StoreState) => {
	const {
		editor: {
			type,
			pagesController: { spreads },
		},
	} = state;

	return {
		isButtonRemoveDisplayed: spreads.length > 1,
		isButtonDuplicateDisplayed: type === EditorType.INDESIGN,
	};
};

export default connect(mapStateToProps)(ButtonsPanel);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/Thumbnails/Column/ButtonsPanel/index.tsx